<template>
  <div class="video-carousel">
    <div class="video-carousel__header">
      <h2 class="video-carousel__title">
        {{ heading }}
      </h2>
    </div>
    <div class="videos">
      <IntersectionObserver
        v-for="video in videos"
        v-slot="{ intersected: videoIntersected }"
        :key="video.id"
        class="video"
        :options="{
          root: null,
          threshold: index === 1 ? 0.15 : 0,
          rootMargin: '0px 0px 0px 0px',
        }"
      >
        <Video :video="video" :intersected="videoIntersected" />
      </IntersectionObserver>
    </div>
  </div>
</template>

<script>
import IntersectionObserver from "@/components/IntersectionObserver.vue";
import Video from "@/components/Video.vue";
export default {
  name: "VideoCarousel",
  components: {
    Video,
    IntersectionObserver,
  },
  props: {
    videos: {
      type: Array,
      default: () => [],
    },
    heading: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.video-carousel {
  background-color: $color-light;
  padding: 60px 0 0;

  @include respond-above(md) {
    padding: 80px 0 0;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 10px;
    padding: 0 10px;

    @include respond-above(md) {
      padding: 0 20px;
    }
  }

  &__title {
    text-transform: uppercase;
    font-size: 18px;
    font-weight: normal;

    @include respond-above(md) {
      font-size: 30px;
    }
  }

  &__link {
    font-size: 8px;
    text-decoration: none;
    text-transform: uppercase;
    color: $color-dark;
    font-weight: 600;

    @include respond-above(md) {
      font-size: 10px;
    }
  }
}

.videos {
  display: flex;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;

  .video {
    flex: 1 0 87.5%;
    margin-right: 2px;

    @include respond-above(md) {
      flex: 1 0 40%;
    }
  }
}
</style>
